namespace Dashboard {
  export const Print = (id: string): void => {
    const element = document.getElementById(id);
    
    if (!element) {
      console.log("No content to print");
      return;
    }
    
    let html = `<html><head>
        <style>
        table, th, td {
          border: 1px solid black;
          border-collapse: collapse;
        }
        </style>
        </head>`;
    html += element.innerHTML;
    html += "</html>";

    const printWin = window.open('RealtiWeb', '_blank', 'left=0,top=0,width=1200,height=1000,toolbar=0,scrollbars=0,status=0');
    printWin.document.write(html);
    printWin.document.getElementsByTagName('table')[0].setAttribute('style', 'width:100%;');
    printWin.document.close();
    printWin.focus();
    printWin.print();
  }
}

export default Dashboard;